export enum WssMethods {
    TASK_NOTIFICATIONS = 'TaskNotifications',
    AGENT_BALANCE = 'AgentBalance',
}
